import { DownloadIcon as Download, Typography } from "@packages/ds";
import styled from "styled-components";

import * as DrawerLayout from "Components/DrawerLayout";
import { Link, BackLink } from "ds/Button";
import * as Table from "ds/Table";

export const DrawerRoot = styled(DrawerLayout.Root)``;

export const DrawerTitle = styled(Typography.Title)`
  margin: 16px 0 32px;
`;
export const OrganizationName = styled(Typography.Title)`
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid
    ${"var(--drawer-divider-section-border-color,var(--section-color-neutral-300-border-color,var(--color-neutral-300)))"};
`;

export const InvoicesPageWrapper = styled.div`
  display: flex;
  margin-left: -40px;
  height: calc(100vh - 96px);
`;
export const InvoicesListSection = styled.div`
  margin: 32px 0 0 32px;
  width: 100%;
  max-height: 100vh;
  display: flex;
  flex-direction: column;

  a {
    text-decoration: none;
  }
  a:hover::after {
    height: 0;
  }
`;
export const TableHeader = styled(Table.Thead)`
  padding: 16px 0;
`;

export const PastInvoiceRow = styled.div`
  display: flex;
  width: 100%;
  cursor: pointer;

  & > :first-child {
    margin-right: 8px;
  }

  & > :last-child {
    margin-left: auto;
  }
`;

export const PaymentPanel = styled.div`
  padding: 24px;
  border-radius: 8px;
  margin-top: 16px;

  &:last-child {
    margin-bottom: 32px;
  }
`;

export const UpcomingEstimatedPayment = styled(PaymentPanel)`
  background: ${"var(--estimated-payment-section-background-color,var(--section-color-primary-100-background-color,var(--color-primary-100)))"};
`;

export const RemainingPrepayment = styled(PaymentPanel)`
  border: 1px solid var(--color-upsun-grey-200);
`;

export const PastInvoicesShortList = styled.div`
  margin-top: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid
    ${"var(--drawer-divider-section-border-color,var(--section-color-neutral-300-border-color,var(--color-neutral-300)))"};
`;

export const InvoiceInterval = styled.div`
  color: ${"var(--invoice-interval-section-color,var(--section-color-neutral-600-color,var(--color-neutral-600)))"};
`;
export const PastInvoiceInterval = styled(Typography.BodyText)`
  color: var(--section-granite-color, var(--granite));
`;

export const TableList = styled(Table.Table)`
  height: fit-content;
  margin-bottom: 24px;
`;
export const TablesListWrapper = styled(Table.Table)`
  max-height: calc(100vh - 96px - 32px);
`;

export const PastInvoices = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const PastInvoiceTitle = styled(Typography.Title)`
  margin: 24px 0;
`;
export const UpcomingEstimatedPaymentAmount = styled.div`
  display: flex;
`;
export const EstimatedPaymentLabel = styled(Typography.BodyText)`
  color: ${"var(--estimated-label-section-color,var(--section-color-neutral-800-color,var(--color-neutral-800)))"};
`;

export const EstimatedAmountCurrency = styled(Typography.BodyText)`
  margin-left: 8px;
  color: ${"var(--amount-currency-section-color,var(--section-color-neutral-600-color,var(--color-neutral-600)))"};
`;

export const PastInvoiceId = styled(Typography.BodyText)`
  color: var(
    --order-id-section-color,
    var(--section-color-primary-600-color, var(--color-primary-600))
  );
`;
export const PastInvoiceAmount = styled(Typography.BodyText)`
  color: var(--section-black-300-color, var(--black-300));
`;

export const PricingPageLink = styled(Link)``;

export const UpcomingInvoiceHeader = styled.div`
  display: flex;
  flex-direction: column;
  margin: 32px 0 24px;
`;
export const UpcomingInvoiceTitle = styled(Typography.Title)`
  margin-bottom: 16px;
`;
export const UpcomingInvoiceDescription = styled(Typography.BodyText)`
  white-space: pre-line;
`;

export const DownloadIcon = styled(Download)`
  fill: var(
    --download-icon-fill,
    var(--icon-color-neutral-600-fill, var(--color-neutral-600))
  );
`;

export const BackToInovicesLink = styled(BackLink)`
  align-self: start;
`;

export const DownloadContainer = styled(Table.Td)`
  justify-content: flex-end;
`;

export const EnterpriseMessageWrapper = styled.div`
  margin-bottom: 24px;
`;

export const InvoicedHeader = styled(Typography.Title)`
  margin-bottom: 32px;
`;
